import { animated, config, useTransition } from '@react-spring/web';
import useComponentSize from '@rehooks/component-size';
import { ReactNode, useRef } from 'react';

import { OfferAccordion } from './OfferAccordion';
import { OfferAccordionContentWrapper } from './OfferAccordionContentWrapper';
import { OfferCardContainer } from './OfferCardContainer';
import { OfferListItemGrid } from './OfferListItemGrid';

interface OfferAccordionCardProps {
    expanded: boolean;
    accordionContent: ReactNode;
    children: ReactNode;
}

export const OfferAccordionCard = ({ expanded, accordionContent, children }: OfferAccordionCardProps) => {
    const accordionContentRef = useRef<HTMLDivElement>(null);
    const { height } = useComponentSize(accordionContentRef);

    const contentAnimation = useTransition(expanded, {
        from: {
            opacity: 0,
            height: 0,
        },
        enter: {
            opacity: 1,
            height: height,
        },
        leave: {
            opacity: 0,
            height: 0,
        },
        update: {
            height: height,
            opacity: 1,
        },
        config: {
            ...config.default,
            duration: 150,
        },
    });

    return (
        <OfferAccordion>
            <OfferCardContainer expanded={expanded}>
                <OfferListItemGrid>{children}</OfferListItemGrid>
            </OfferCardContainer>

            {contentAnimation((style, item) =>
                item ? (
                    <animated.div style={{ ...style, overflow: 'hidden' }}>
                        <OfferAccordionContentWrapper ref={accordionContentRef}>
                            {accordionContent}
                        </OfferAccordionContentWrapper>
                    </animated.div>
                ) : null
            )}
        </OfferAccordion>
    );
};
